import VendorOrderSection from "@/app/checkout/(squeeze)/review/twoDayDeliveryExperience/vendorOrderSection";
import { CheckoutOrder } from "@/fetch/getCheckoutResponse";

export default function TwoDayDeliveryVendor({
  vendors,
  isConfirmationPage,
}: {
  vendors: CheckoutOrder[];
  isConfirmationPage: boolean;
}) {
  return (
    <>
      {vendors?.map((vendorOrder, index) => (
        <VendorOrderSection key={index} vendorOrder={vendorOrder} isConfirmationPage={isConfirmationPage} />
      ))}
    </>
  );
}
